import type { AccentConfig, LangConfig } from './types';

/** Multi-accent options from the design handoff (orange default). */
export const accentConfigs: AccentConfig[] = [
  { name: 'orange', label: 'Spice', previewColor: '#f2541b' },
  { name: 'green', label: 'Mint', previewColor: '#1b9c5d' },
  { name: 'blue', label: 'Ocean', previewColor: '#2d7ff9' },
  { name: 'purple', label: 'Grape', previewColor: '#7c5cfc' },
  { name: 'forest', label: 'Kirana', previewColor: '#166534' }
];

/** Supported languages: EN / हिंदी / ಕನ್ನಡ. */
export const langConfigs: LangConfig[] = [
  { code: 'en', label: 'EN', native: 'English' },
  { code: 'hi', label: 'हिं', native: 'हिंदी' },
  { code: 'kn', label: 'ಕ', native: 'ಕನ್ನಡ' }
];
